export default __webpack_public_path__ + "static/media/MITRE.a5b63844.svg";